export default __webpack_public_path__ + "static/media/7.38f44254.svg";